import { Dialog } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

interface CertificationSpecialCreditsModalProps {
	specialCredits: number;
	note: string;
}

const CertificationSpecialCreditsModal = ({
	specialCredits,
	note,
}: CertificationSpecialCreditsModalProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<>
			<button
				onClick={() => setIsModalOpen(true)}
				className="flex items-center gap-3 rounded-xl border px-3 py-2.5 hover:bg-slate-50/70 sm:border-none dark:hover:bg-slate-700/50"
			>
				<span className="box-content flex w-12 shrink-0 items-center justify-center rounded-full bg-amber-200/80 p-1 py-0.5 font-bold text-sm dark:bg-amber-200 dark:text-slate-700">
					{specialCredits}
				</span>

				<span>Special Credits</span>
			</button>

			<AnimatePresence mode="wait">
				<Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
					<motion.div
						className="fixed inset-0 bg-black/20 dark:bg-black/50"
						initial={{ opacity: 0 }}
						animate={{
							opacity: 1,
							transition: {
								duration: 0.2,
							},
						}}
						exit={{
							opacity: 0,
							transition: {
								duration: 0.2,
							},
						}}
					>
						<motion.div className="fixed inset-0 flex items-center justify-center overflow-y-auto p-4">
							<Dialog.Panel
								as={motion.div}
								initial={{ opacity: 0 }}
								animate={{
									opacity: 1,
									transition: {
										duration: 0.2,
									},
								}}
								exit={{
									opacity: 0,

									transition: {
										duration: 0.1,
									},
								}}
								className="relative mx-auto flex max-h-[70vh] w-full max-w-xl flex-col overflow-hidden overflow-y-auto rounded-xl px-4 py-4 shadow-black/10 shadow-xl dark:bg-slate-800 dark:shadow-black/10"
							>
								<h2 className="text-center font-bold text-xl">
									<span className="mr-1 rounded-md bg-amber-50 px-1.5 text-amber-900 dark:bg-amber-200 dark:text-slate-700">
										{specialCredits}
									</span>{" "}
									Special Credits
								</h2>
								<p className="!text-amber-900 dark:!text-amber-50 mt-5 rounded-md bg-amber-50 px-2 py-2 text-left dark:bg-amber-300/20">
									<strong>Note:</strong> {note}
								</p>
							</Dialog.Panel>
						</motion.div>
					</motion.div>
				</Dialog>
			</AnimatePresence>
		</>
	);
};

export default CertificationSpecialCreditsModal;
